import { API_STATE_UPDATE_CALL_STATUS, apiStateUpdateCallStatusReducer, } from './apiStateUpdateCallStatus';
import { createSubReducer } from '../../utils/store';
const initialState = {
    callStatuses: [],
};
const reducers = [
    {
        type: API_STATE_UPDATE_CALL_STATUS,
        reducer: apiStateUpdateCallStatusReducer,
    },
];
export const apiStateReducer = createSubReducer(initialState, reducers);
//# sourceMappingURL=reducer.js.map